import classnames from 'classnames'
import Link from 'next/link'
import React, { FC } from 'react'

/* eslint-disable jsx-a11y/anchor-is-valid */
export interface BaseCardProps {
    boxShadow?: boolean
    cardType:
        | 'narrow'
        | 'wide'
        | 'tall'
        | 'myStats'
        | 'featured'
        | 'featuredWide'
        | 'xl'
        | 'xxl'
        | 'blog'
        | 'tracker'
        | 'myStatsCondensed'
        | null
    href?: string
    selected?: boolean | null
    onClick?: () => void
    isMerchCard?: boolean
}

export const BaseCard: FC<BaseCardProps> = ({
    boxShadow,
    href,
    selected = null,
    onClick = () => null,
    isMerchCard = false,
    ...props
}) => {
    const merchCardStyles = classnames('flex', 'flex-col', 'pt-2', 'px-2', 'z-10')
    const size = () => {
        switch (props.cardType) {
            case 'xl':
                return ['w-[300px]', 'h-[400px]', 'md:w-[500px]', 'md:h-[500px]'].map(
                    (style) => style
                )
            case 'tall':
                return ['w-[268px]', 'h-[460px]'].map((style) => style)
            case 'featuredWide':
                return ['w-5/6', 'h-auto'].map((style) => style)
            case 'myStats':
                return ['w-[320px]', 'h-auto'].map((style) => style)
            case 'myStatsCondensed':
                return ['w-[250px]', 'h-auto'].map((style) => style)
            case 'blog':
                return ['w-[225px]', 'h-[215px]'].map((style) => style)
            case 'tracker':
                return ['w-[225px]', 'h-[215px]'].map((style) => style)
            default:
                return ['w-[225px]', 'h-[300px]'].map((style) => style)
        }
    }

    const card = classnames(
        'cursor-pointer',
        'bg-white',
        'rounded-2xl',
        'overflow-hidden',
        'relative',
        'border-0',
        'border-solid',
        'border-transparent',
        'relative',
        size(),
        {
            'border-yf-green': !!selected,
            'shadow-xl': !!boxShadow,
            [merchCardStyles]: isMerchCard
        }
    )

    if (href) {
        return (
            <Link href={href} passHref scroll={true}>
                <a onClick={() => window.scrollTo(0, 0)} className="no-underline block">
                    <div className={card}>{props.children}</div>
                </a>
            </Link>
        )
    }

    return (
        <div onClick={onClick} className={card}>
            {props.children}
        </div>
    )
}
